<template>
  <div style="margin-top: 86px">
    <div class="product-detail-empty" v-if="!finished">
    </div>
    <div class="product-detail" v-if="finished">
      <div class="product-detail-top">
        <el-breadcrumb separator="/" class="product-detail-breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path:this.productInfo.productCategoryRouter, query:{productCategoryId:this.productInfo.productCategoryId}}">{{this.categoryRouter}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{this.productInfo.productName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="block" style="margin: auto;width: 70%;height: 400px">
        <el-carousel :interval="4000" height="400px" indicator-position="outside">
          <el-carousel-item v-for="item in this.productInfo.productPicList" :key="item.id">
            <el-image
                    :src="item.imgUrl"
                    fit="contain"
                    class="image"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="product-detail-title">
        {{this.productInfo.productTitle}}
      </div>
      <div class="product-detail-content" v-html="this.productInfo.productBrief">
      </div>

      <div class="product-detail-item" v-for="item in this.productInfo.productContentList" :key="item.productContentId">
        <div class="product-detail-item-tag">
          {{item.productContentName}}
        </div>
        <div class="product-detail-item-content-block">
          <ul>
            <li class="product-detail-item-content" v-for="item2 in item.productContentDetailList" :key="item2.productContentDetailId">
              {{item2.productContentDetail}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'ProductDetail',
  data() {
    return {
      finished: false,
      productId: '',
      categoryRouter: '',
      productInfo: null
    }
  },
  methods: {
    initProductDetail() {
      this.finished = false;
      let url = '/product/productDetail?productId=' + this.productId;
      this.getRequest(url).then(resp => {
        if (resp.obj) {
          this.productInfo = resp.obj;
          if(this.productInfo.productPicList && this.productInfo.productPicList.length > 0){
            var _this = this;
            _this.productInfo.productPicList.forEach(row => {
              var imgUrl = _this.baseUrl + '/pic/viewPic?picId=' + row.picId;
              row.imgUrl = imgUrl;
            })
          }
        }
        this.finished = true;
      });
    }
  },
  mounted() {
    this.initProductDetail();
  },
  created() {
    this.categoryRouter = this.$route.params.categoryRouter;
    this.productId = this.$route.params.productId;
  },
  /*监测路由的变化 */
  watch: {
    $route(to, from) {
      this.categoryRouter = this.$route.params.categoryRouter;
      this.productId = this.$route.params.productId;
      this.initProductDetail();
    }
  }
}
</script>

<style src="../../assets/css/productDetail.css" scoped>

</style>
